<template>
    <div id="create_record" class="collapse">
        <form class="form-horizontal throttle">
            <div class="form-group row">
                <label for="name" class="col-md-3 col-form-label text-right">Name</label>
                <div class="col-md-9">
                    <input id="name" type="text" v-model="fields.name" class="form-control">
                </div>
            </div>
            <div class="form-group row">
                <label for="desc" class="col-md-3 col-form-label text-right">Description</label>
                <div class="col-md-9">
                    <textarea id="desc" v-model="fields.desc" rows="2" class="form-control"></textarea>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-9 ml-auto">
                    <button class="btn btn-primary" type="submit" @click.prevent="handleCreateProject()">
                        Save
                    </button>
                    <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#create_record">
                        Cancel
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<style scoped lang="scss">
</style>

<script type="text/javascript">
var baseUrl = window.location.protocol + "//" + window.location.host;
import axios from "axios";
export default {
    name: "CreateProjectForm",
    props: ['post'],
    data() {
        return {
            apiUrl: `${baseUrl}/${this.endpoint}`,
            loading: true,
            fields: {
                name: '',
                desc: ''
            }
        }
    },
    methods: {
        handleCreateProject() {
            axios
                .post(`${this.post}`, this.fields).then((res) => {
                    window.location.reload();
                });
        }
    }
}
</script>
